import { h, defineComponent } from "vue";
import { DefaultVueProp } from "./vueHelpers";

/** KeepAlive only supports components, not DOM elements, fragments, or functional components.
 * Use this when you want to keep a plain DOM element alive.
 */
export const KeptAlive = defineComponent({
    name: "KeptAlive",
    props:
    {
        tag: DefaultVueProp("div")
    },
    setup(props, { slots, attrs })
    {
        return () => h(props.tag, attrs, slots.default?.());
    }
});